let mapper_options = {
  endpoint: 'facebook_accounts',
  recordClass: require('./record')
}

module.exports = (store) => {
  store.defineMapper('facebook_account', mapper_options)
}